import React from 'react';
import { Card } from '@frontend/shadcn/components/ui/card';
import {
  HighlightCardHeader,
  HighlightCardHeaderRow,
  HighlightCardTitle,
  HighlightCardContent,
  HighlightCardContentRow,
  HighlightCardContentColumn,
  HighlightCardStatRow,
  HighlightCardStat,
  HighlightCardStatLabel,
} from '../../../components/highlight-card';

interface EmptyHighlightCardProps {
  title: string;
  iconComponent: React.ReactNode;
  backgroundColor: string;
  valueType: 'currency' | 'percentage';
  showNonAttributedData?: boolean;
}

export const EmptyHighlightCard = React.forwardRef<HTMLDivElement, EmptyHighlightCardProps>(
  ({ title, iconComponent, backgroundColor, valueType, showNonAttributedData = false }, ref) => (
    <Card ref={ref}>
      <HighlightCardHeader className={backgroundColor} role="banner">
        <HighlightCardHeaderRow>
          <HighlightCardTitle>
            {iconComponent}
            <span className="text-base">{title}</span>
          </HighlightCardTitle>
        </HighlightCardHeaderRow>
      </HighlightCardHeader>
      <HighlightCardContent>
        <HighlightCardContentRow>
          <HighlightCardContentColumn className={showNonAttributedData ? '' : 'col-span-full'}>
            <HighlightCardStatRow>
              <HighlightCardStat
                className="text-3xl leading-none text-[#cbd1d7]"
                role="status"
                aria-label={`${title} data unavailable`}
              >
                {valueType === 'currency' ? '$-' : valueType === 'percentage' ? '-.0x' : '-'}
              </HighlightCardStat>
            </HighlightCardStatRow>
            <HighlightCardStatLabel className="text-[#cbd1d7]">Attributed to Aspire</HighlightCardStatLabel>
            <div className="flex items-center gap-1 text-xs text-[#cbd1d7]">
              <span>-%</span>
              <span>No data available</span>
            </div>
          </HighlightCardContentColumn>
          {showNonAttributedData && (
            <HighlightCardContentColumn className="xs:items-start sm:items-end md:items-start xl:items-end">
              <HighlightCardStatRow>
                <HighlightCardStat
                  className="text-3xl leading-none text-[#cbd1d7]"
                  role="status"
                  aria-label={`${title} not attributed to Aspire data unavailable`}
                >
                  {valueType === 'currency' ? '$-' : valueType === 'percentage' ? '-.0x' : '-'}
                </HighlightCardStat>
              </HighlightCardStatRow>
              <HighlightCardStatLabel className="text-[#cbd1d7]">Not Attributed to Aspire</HighlightCardStatLabel>
              <div className="flex items-center gap-1 text-xs text-[#cbd1d7]">
                <span>-%</span>
                <span>No data available</span>
              </div>
            </HighlightCardContentColumn>
          )}
        </HighlightCardContentRow>
      </HighlightCardContent>
    </Card>
  ),
);

EmptyHighlightCard.displayName = 'EmptyHighlightCard';
